var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-tag-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.tagsToAdd")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: {
              mode: "multiple",
              placeholder: _vm.$t("taskModuleRules.selectTags"),
            },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.tagIds,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "tagIds", $$v)
              },
              expression: "localConfig.tagIds",
            },
          },
          _vm._l(_vm.taskTags, function (tag) {
            return _c(
              "a-select-option",
              { key: tag._id, attrs: { value: tag._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(tag.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }